import React from 'react';
import { Box } from '@material-ui/core';
import styles from './style';

/**
 * @name InfoTileIcon
 * @param {object} props - Strapi Data
 * @returns {JSX.Element} - Renders Image component
 */
const InfoTileIcon = props => {
    const classes = styles();

    return (
        <Box
            component='img'
            src={`${window.origin}${props?.icon?.data?.attributes?.url}`}
            alt={props?.icon?.data?.attributes?.alternativeText}
            className={classes.infoTileIcon}
        />
    );
};
InfoTileIcon.displayName = 'InfoTileIcon';
export default InfoTileIcon;
